import React from 'react'
import { Link } from 'react-router-dom'
import MobileMenu from '../MobileMenu/MobileMenu'

const Header = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const BASE_URL = 'https://pharmacyfreedomfund.com';
    // Define internal nav as relative paths for SPA navigation with Link
    const navItems = [
        { name: 'Home', path: '/' },
        { name: 'For Investors', path: '/for-investors' },
        { name: 'For Pharmacies', path: '/for-pharmacies' },
        { name: 'Newsroom', path: '/newsroom' },
        { name: 'About Us', path: '/about-us' },
        { name: 'Contact Us', path: '/contact-us' },
    ];

    return (
        <header id="header">
            <div className={props.hclass}>
                <nav className="navigation navbar navbar-expand-lg navbar-light" aria-label="Primary">
                    <div className="container-fluid">
                        <div className="row align-items-center">
                            <div className="col-lg-3 col-md-3 col-3 d-lg-none dl-block">
                                <MobileMenu />
                            </div>
                            <div className="col-lg-2 col-md-6 col-6">
                                <div className="navbar-header">
                                    <Link onClick={ClickHandler} className="navbar-brand" to="/" aria-label="Pharmacy Freedom Fund Home">
                                        <img src={props.Logo} alt="Pharmacy Freedom Fund" />
                                    </Link>
                                </div>
                            </div>
                            <div className="col-lg-7 col-md-1 col-1">
                                <div id="navbar" className="collapse navbar-collapse navigation-holder">
                                    <button className="menu-close"><i className="ti-close"></i></button>
                                    <ul className="nav navbar-nav mb-2 mb-lg-0" itemScope itemType="https://schema.org/SiteNavigationElement">
                                        {navItems.map((item) => (
                                            <li key={item.path}>
                                                <Link itemProp="url" to={item.path} onClick={ClickHandler}>{item.name}</Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-2 col-2">
                                <div className="header-right">
                                    <a href="https://portal.pharmacyfreedomfund.com/" className="theme-btn">Invest Now</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
                {/* JSON-LD for Site Navigation to improve crawlability */}
                <script type="application/ld+json" dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                        '@context': 'https://schema.org',
                        '@type': 'ItemList',
                        'itemListElement': navItems.map((item, index) => ({
                            '@type': 'SiteNavigationElement',
                            'position': index + 1,
                            'name': item.name,
                            // Use absolute URLs in JSON-LD
                            'url': `${BASE_URL}${item.path}`,
                        })),
                    })
                }} />
                {/* JSON-LD for Organization and WebSite */}
                <script type="application/ld+json" dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                        '@context': 'https://schema.org',
                        '@graph': [
                            {
                                '@type': 'Organization',
                                'name': 'Pharmacy Freedom Fund',
                                'url': BASE_URL,
                                'logo': {
                                    '@type': 'ImageObject',
                                    'url': `${BASE_URL}/Logo-freedom-color-white-bg.png`
                                }
                            },
                            {
                                '@type': 'WebSite',
                                'name': 'Pharmacy Freedom Fund',
                                'url': BASE_URL
                            }
                        ]
                    })
                }} />
            </div>
        </header>
    )
}

export default Header;

